export enum RDWDocumentStatus {
    Available = 'Available',
    Missing = 'Missing',
  }
  

  export enum DownloadSource {
    TRRF = "TRRF",
    ONESTOP = "ONESTOP",
    ORDERS_BLOB = "ORDERS_BLOB",
  }
  